import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'acc-cohort-tab-2-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-cohort-tab-2.part.html',
})
export class AccCohortTab2Part {
}
